export const functionKeySymbol = () => {
  return window.navigator.platform == 'MacIntel' ? '⌘' : 'Ctrl + '
}



// WEBPACK FOOTER //
// ./app/util/system.js